export function shouldRequestPopupContent({
    alwaysRefresh = false,
    hasForm = false,
    hasLeadInfo = false,
} = {}) {
    return alwaysRefresh || (!hasForm && !hasLeadInfo);
}
